import React, { useState } from "react";
import Modal from "../common/Modal";

const BannerCards = () => {

    const [open, setOpen] = useState(null);

    return (
        <div className="banner-cards">

            <div
                className="card banner"
                onClick={() => setOpen("nbfc")}
            >
                NBFC Finance
            </div>

            <div
                className="card banner"
                onClick={() => setOpen("logistics")}
            >
                Logistics Inquiry
            </div>

            <Modal
                open={open === "nbfc"}
                title="NBFC Inquiry"
                onClose={() => setOpen(null)}
            >
                NBFC FORM HERE
            </Modal>

            <Modal
                open={open === "logistics"}
                title="Logistics Inquiry"
                onClose={() => setOpen(null)}
            >
                Logistics FORM HERE
            </Modal>

        </div>
    );
};

export default BannerCards;